"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useLayoutEffect } from "react";

import { fetchPlanUsage } from "@/hooks/queries/usePlanUsageQuery";
import { useCurrentUser } from "@/hooks/queries/useCurrentUser";
import { queryKeys } from "@/lib/react-query/query-keys";

/** Warm plan usage counts so limit gates can resolve instantly. */
export function PlanUsagePrefetch() {
  const qc = useQueryClient();
  const { data: user } = useCurrentUser();

  useLayoutEffect(() => {
    if (!user?.id) return;
    void qc.prefetchQuery({
      queryKey: queryKeys.planUsage(),
      queryFn: fetchPlanUsage,
    });
  }, [qc, user?.id]);

  return null;
}
